import { useContext } from 'react';

import { CartContext } from '../context/cart/CartContext';

const useCart = () => useContext(CartContext);

export default useCart;
